export const UNSAVED_CHANGES_PROMPT = 'You have unsaved changes. Are you sure you want to leave?';
export const MAX_WIDTH_STYLE = 'calc(100% - 320px)';
